import { Link } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { SIGN_OUT_URL, sendJson } from '../api.ts';

/** Signed in, but the address is not on the Users list (or is switched off). */
export function NoAccess({ email, reason, applyOpen }: { email: string; reason: 'unlisted' | 'inactive'; applyOpen: boolean }) {
  // Tell the administrators once (the server keeps it to one alert per address per 6 h).
  const told = useRef(false);
  useEffect(() => {
    if (told.current) return;
    told.current = true;
    void sendJson('POST', '/api/access-refused').catch(() => undefined);
  }, []);

  return (
    <div className="landing">
      <h1>No access yet</h1>
      <p>
        You are signed in as <strong>{email}</strong>.{' '}
        {reason === 'inactive' ? 'This address is switched off in the Research Hub.' : 'This address is not on the Research Hub list.'}
      </p>
      <p>
        If you were invited at a <em>different</em> address, sign out and sign in with that one — or reply to your invitation email with the
        address above. An administrator has been told.
      </p>
      <p>
        <a className="btn alt" href={SIGN_OUT_URL}>Sign out and use another address</a>
      </p>
      {applyOpen && reason === 'unlisted' && (
        <p>
          Here to apply for a research topic? <Link to="/apply">See the open topics</Link> or <Link to="/my-applications">continue as an applicant</Link>.
        </p>
      )}
    </div>
  );
}
